import PropTypes from 'prop-types';

const ResponsiveImageSource = {};

ResponsiveImageSource.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  media: PropTypes.number,
};

export default ResponsiveImageSource;
